import { useContext } from "react";
import { AppRequestsContext } from "../components/app-requests-provider";
import { AppRequests } from "../models/app-requests-model";

export const useAppRequests = (): AppRequests => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return useContext(AppRequestsContext)!;
};
